<template>
    <v-container class="my-5">
        <v-dialog
                v-model="dialogData"
                persistent
                scrollable
                width="700">
            <v-card class="mx-auto elevation-7">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('access_without_code')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="clear(), dialogData = false"
                    ><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text align="center">
                    <v-row>
                        <v-col>
                            <img  width="400" height="250" :src="imageCaptured">
                            <v-autocomplete
                                    autofocus
                                    v-model="idHouse"
                                    prepend-icon="mdi-home-city"
                                    name="idHouse"
                                    :item-text="example"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errors.house"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    outlined
                                    autocomplete="off"
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                </template>
                            </v-autocomplete>
                            <v-text-field
                                    v-model="first_name"
                                    autofocus
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    outlined
                                    :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    outlined
                                    :error-messages="errors.name_guest"
                            >
                            </v-text-field>
                            <v-textarea
                                    v-model="notes"
                                    prepend-icon="mdi-text"
                                    name="notes"
                                    :placeholder="$t('placeholder_notas')"
                                    :label="$t('Notas')"
                                    outlined
                                    :error-messages="errors.comments"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            large
                            color="primary"
                            @click="createAccessWithoutCode()"
                            :loading="loading"
                    >{{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h1 class="subheading grey--text">{{$t('acceso_sin_codigo')}}</h1>
        <v-layout align-center justify-center fill-height>
            <v-card color="primary" width="600" align="center">
                <v-card-title class="text-center justify-center">
                    <h2>
                        {{$t('lanesCam')}}
                    </h2>
                </v-card-title>
                <v-tabs
                        v-model="tab"
                        centered
                        grow
                        icons-and-text
                        background-color="primary"
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                            v-for="(item, i) in camDevices"
                            :key="i"
                            :href="'#tab-' + i"
                    >
                        <v-badge
                                overlap
                                color="orange"
                        >
                            <template v-slot:badge>
                                <v-icon
                                        v-if="item.data"
                                        dark
                                >
                                    mdi-bell-ring
                                </v-icon>
                            </template>
                            {{ item.label }}
                            <v-icon large>
                                mdi-camera
                            </v-icon>
                        </v-badge>
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item
                            v-for="(item, i) in camDevices"
                            :key="i"
                            :value="'tab-' + i"
                    >
                        <v-card flat>
                            <v-card-text>{{item.name}}</v-card-text>
                            <v-list three-line v-if="item.data">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            large
                                                            color="red"
                                                            dark
                                                            class="mr-2"
                                                            :loading="loading"
                                                            @click="labelDevice = item.label, deleteRecord()"
                                                    >
                                                        mdi-close
                                                    </v-icon>
                                                </template>
                                                <span>{{$t('delete')}}</span>
                                            </v-tooltip>
                                            {{$t('foto_ine')}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <img width="400" height="250" :src="'data:image/jpeg;base64,' + item.data">
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            medium
                                                            color="primary"
                                                            class="mr-2"
                                                            @click="dialogData = true, imageCaptured = 'data:image/jpeg;base64,' + item.data, labelDevice = item.label"
                                                    >
                                                        <v-icon>
                                                            mdi-magnify
                                                        </v-icon>
                                                        {{$t('show_details')}}
                                                    </v-btn>
                                                </template>
                                                <span>{{$t('show_details')}}</span>
                                            </v-tooltip>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-list v-else>
                                <div>{{$t('no_registros_pase_salida')}}</div>
                            </v-list>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-layout>
    </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import store from '@/store'

export default {
  name: 'access_without_code_cam',
  data () {
    return {
      tab: null,
      dialogData: false,
      houses: [],
      errors: [],
      first_name: '',
      last_name: '',
      celular: '',
      notes: '',
      idHouse: '',
      imageCaptured: '',
      loading: false,
      labelDevice: ''
    }
  },
  created () {
    this.getHouses()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['camDevices'])
  },
  methods: {
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    createAccessWithoutCode () {
      this.loading = true
      this.errors = []
      console.log('Access Without Code Created ....')
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('housing_unit', this.getProfile.idHousingUnit)
      bodyFormData.set('house', this.idHouse)
      bodyFormData.set('name_guest', this.first_name + ' ' + this.last_name)
      bodyFormData.set('comments', this.notes)
      bodyFormData.set('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))

      if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
        fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
      }
      bodyFormData.append('photo', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          this.dialogData = false
          this.deleteRecord()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')',
    customFilter (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cleanFields () {
      this.errors = []
      this.notes = ''
      this.idHouse = ''
      this.first_name = ''
      this.last_name = ''
    },
    clear () {
      this.cleanFields()
      this.errors = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    deleteRecord () {
      if (localStorage.getItem('cam_devices') !== null) {
        let band = false
        let devicesAux = JSON.parse(localStorage.getItem('cam_devices'))
        console.log('Auxiluar = ', devicesAux)
        for (let i = 0; !band && i < devicesAux.length; i++) {
          if (devicesAux[i].label === this.labelDevice) {
            console.log(devicesAux[i].label, '===', this.labelDevice)
            devicesAux[i] = Object.assign(devicesAux[i], { 'data': null })
            localStorage.setItem('cam_devices', JSON.stringify(devicesAux))
            this.$store.commit('setCamDevices', JSON.parse(localStorage.getItem('cam_devices')))
            band = true
          }
        }
        console.log(JSON.parse(localStorage.getItem('cam_devices')))
      }
    }
  }
}
</script>

<style scoped>

</style>
